import { useNavigate, useParams } from 'react-router-dom';
import { AdminDemoDefiniton } from '../../types';
import { Layout } from '../../components/layout';
import { Button, Header, Modal, SpaceBetween, Box } from '@cloudscape-design/components';
import { useAuth } from 'react-oidc-context';
import { getEndpoint } from '../../utils';
import DemoForm from '../../components/admin/DemoForm';
import { useEffect, useState } from 'react';

export default function EditDemo() {
  const navigate = useNavigate();
  const auth = useAuth();
  const { path } = useParams();
  const [demo, setDemo] = useState<AdminDemoDefiniton>();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    if (!auth.isAuthenticated) {
      auth.signinRedirect({
        url_state: encodeURIComponent(window.location.pathname)
      });
    }
    if (auth.user?.profile?.['custom:groups'] !== undefined && auth.user?.profile?.['custom:groups'] !== null) {
      const groups = JSON.parse(auth.user.profile['custom:groups'] as string);
      if (!groups.includes('admin')) {
        window.location.href = '/';
      }
    }
    auth.startSilentRenew();
    if (auth.isAuthenticated && !demo) {
      if (!auth.user?.id_token) {
        throw new Error('No access token available');
      }
      auth.startSilentRenew();
      const token = auth.user.id_token;
      if (!token) {
        return;
      }
      auth.startSilentRenew();
      const endpoint = getEndpoint(`/api/admin/demos/${encodeURIComponent(path!)}`)
      console.log("endpoint", endpoint)
      fetch(endpoint, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      }).then((response) => {
        if (!response.ok) {
          response.text().then((t) => console.error(t));
        } else {
          response.json().then((data) => {
            setDemo(data);
          });
        }
      }).catch((e) => {
        console.error(e);
      });
    }
  }, [auth, demo, path]);

  const handleSubmit = async (demo: AdminDemoDefiniton) => {
    try {
      auth.startSilentRenew();
      const response = await fetch(getEndpoint('/api/admin/demos'), {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth?.user?.id_token}`,
        },
        body: JSON.stringify(demo)
      });
      console.log('Response:', response);
      const data = await response.json();
      console.log('Data:', data);
      if (response.ok) {
        navigate('/admin');
      }
    } catch (error) {
      console.error('Failed to save demo:', error);
    }
  };

  const handleDelete = async () => {
    try {
      auth.startSilentRenew();
      const response = await fetch(getEndpoint(`/api/admin/demos/${encodeURIComponent(path!)}`), {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${auth?.user?.id_token}`,
        }
      });
      if (response.ok) {
        navigate('/admin');
      }
    } catch (error) {
      console.error('Failed to delete demo:', error);
    }
  };

  return (
    <Layout>
      <SpaceBetween direction="vertical" size="l">
        <Header
          variant="h1"
          actions={
            <Button variant='normal' onClick={() => setShowDeleteModal(true)}>
              Delete Demo
            </Button>
          }
        >
          Edit Demo
        </Header>
        <DemoForm onSubmit={handleSubmit} type='edit' demo={demo} />
        <Modal
          visible={showDeleteModal}
          onDismiss={() => setShowDeleteModal(false)}
          header="Delete Demo"
          footer={
            <Box float="right">
              <SpaceBetween direction="horizontal" size="xs">
                <Button onClick={() => setShowDeleteModal(false)}>Cancel</Button>
                <Button variant='normal' onClick={handleDelete}>
                  Delete
                </Button>
              </SpaceBetween>
            </Box>
          }
        >
          Are you sure you want to delete this demo? This action cannot be undone.
        </Modal>
      </SpaceBetween>
    </Layout>
  );
}
